import React from 'react';
import PropTypes from 'prop-types';

import TickerTapeInsert from './TickerTapeInsert';
import withModal from '../../../../../../../../components/global/modal/withModal';

export const TICKER_TAPE_INSERT_MODAL = 'modal/TICKER_TAPE_INSERT';

const propTypes = {
  actionProps: PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
  }),
};
const TickerTapeInsertModal = ({ actionProps, ...props }) => {
  return (
    <TickerTapeInsert
      text={actionProps?.text}
      color={actionProps?.color}
      backgroundColor={actionProps?.backgroundColor}
      {...props}
    />
  );
};

TickerTapeInsertModal.propTypes = propTypes;

export default withModal(TickerTapeInsertModal, {
  name: TICKER_TAPE_INSERT_MODAL,
  contentLabel: <p className="w-100 text-center mb-0 h3">Ticker tape banner</p>,
  size: 'sm',
  type: 'full',
});
